export default "__VITE_ASSET__0ZEGpsY3__"